<template>
  <b-form-group :label="label">
    <b-input-group>
      <b-form-input readonly @input="$emit('input', $event.target.value);"  ref="input" class="col-sm-2" type="text" :name="name" v-model="item.id" placeholder="ID" :state="state" ></b-form-input>
      <b-form-input type="text" :name="name+'_desc'"  v-model="item.label" class="col-sm-8" :placeholder="placeholder" readonly :state="state" ></b-form-input>
      <b-input-group-append>
        <b-button v-if="!readonly" variant="success" class="" @click="doShowModal()">selecionar</b-button>
        <b-button v-if="!readonly" variant="danger" class=""  @click="clear()"><i class="fa fa-times"></i></b-button>
      </b-input-group-append>
    </b-input-group>
    <b-modal  no-enforce-focus @shown="showModal=true" @hidden="showModal=false" size="xl" ref="selectorModal" >
      <component v-bind:is="modal" :filters="filters"  v-if="showModal" v-on:select-item="itemSelected"></component>
    </b-modal>
  </b-form-group>
</template>

<script>
import Vue from 'vue'
import FamilyModal from '@/views/families/modal.vue'
import FamilyMemberModal from '@/views/familymembers/modal.vue'
import ActivitiesModal from '@/views/activities/modal.vue'
import SubactivitiesModal from '@/views/subactivities/modal.vue'

Vue.component('families-modal', FamilyModal)
Vue.component('familymembers-modal', FamilyMemberModal)
Vue.component('activities-modal', ActivitiesModal)
Vue.component('subactivities-modal', SubactivitiesModal)

export default {
  name: 'modal-select',
  $_veeValidate: {
    // value getter
    value() {
      return this.item.id;
    },
    // name getter
    name() {
      return this.name;
    }
  },
  props: ['name', 'state', 'itemId', 'itemName', 'itemCode', 'readonly', 'placeholder', 'label', 'modal', 'namevar'],
  data() {
    return {
      filters: null,
      showModal: false,
      item: {
        id: null,
        label: ''
      }
    }
  },
  methods: {
    clear() {
      this.item.id = null
      this.item.label = null
      this.$emit('select-item', {
        item: null
      })
      this.$emit('input', this.item.id)
    },
    itemSelected(e) {
      this.item.id = e.item.id
      if(this.namevar) {
        this.item.label = e.item[this.namevar]
      } else {
        this.item.label = e.item.name
      }
      console.log('item selected', e.item)
      this.$emit('select-item', {
        item: e.item
      })
      this.$emit('input', this.item.id)
      this.hideModal()
    },
    doShowModal() {
      this.$refs.selectorModal.show()
    },
    hideModal() {
      this.$refs.selectorModal.hide()
    }
  },
  mounted() {
    // this.$refs.input.value = this.item.id;
  },
  created() {
    this.item.id = typeof this.itemId == 'undefined' ? '': this.itemId
    this.item.label = this.itemName
    this.item.code = this.itemCode
  }
}
</script>
